import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

enableProdMode();

(<any>window).workingRequests = [];
(<any>window).bootApp = function () {
	platformBrowserDynamic()
		.bootstrapModule(AppModule)
		.catch((err) => console.log(err));
};

(<any>window).shouldRunTest = function (testName) {
	if ((<any>window).allTests && (<any>window).allTests.includes(testName)) {
		return true;
	}
	return false;
};

(<any>window).allTests = [];
